export const ON_SET_CHAT_REQUEST = 'ON_SET_CHAT_REQUEST';
export const ON_SET_CHAT_SUCCESS = 'ON_SET_CHAT_SUCCESS';
export const ON_SET_CHAT_FAILED = 'ON_SET_CHAT_FAILED';
export const ON_POST_CHAT_REQUEST = 'ON_POST_CHAT_REQUEST';
